import React, { useContext, useEffect, useState } from "react";
import PageHeading from "../../Components/PageHeading/PageHeading";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";
import "./CompanionAi.css";
import arrowIcon from "../../Assets/Images/arrow-icon.png";
import { Button, Tooltip, Form, Alert, Modal } from "antd";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import CompanionVoiceSelect from "./CompanionVoiceSelect";
import { voices } from "../VideoAi/api";
import { Howl } from "howler";
import { useRef } from "react";
import { GoMute, GoUnmute } from "react-icons/go";
import ReactMarkdown from "react-markdown";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import reload from "../../Assets/Images/relaoder.png";
import { questionsAsk } from "./ConsultantQuestions";

const CompanionAi = () => {
  const { AIuser, tokenLocal, userRefetch, setUserRefetch } =
    useContext(UserAuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(true);

  const [generatingtext, setGeneratingText] = useState("");
  const [text, setText] = useState("");
  const loggedinUser = AIuser?.name;
  const [questions, setQuestions] = useState("What is your name?");
  const [userName, setUserName] = useState("");
  const [loadingMsg, setLoadinMsg] = useState("");
  const [chatbotName, setChatbotName] = useState("");
  const [gender, setGender] = useState("Male");
  const [percent, setPercent] = useState(0);
  const [nameSubmitted, setnameSubmitted] = useState(location?.state?.aiType === "Consultant Ai");
  const [defaultValue, setDefaultValue] = useState("");
  const [voice, setVoice] = useState(defaultValue);
  const [usingChat, setUsingChat] = useState(location?.state?.aiType === "Consultant Ai");
  const [showAlert, setShowAlert] = useState(false);
  const [isRestarted, setIsRestarted] = useState(false);
  const [audioDuration, setAudioDuration] = useState();
  const [isPlaying, setIsPlaying] = useState(false);
  const [isShort, setIsShort] = useState(location?.state?.aiType === "Consultant Ai" ? false : true);
  const [isHaveViewMessage, setIsHaveViewMessage] = useState(false);
  const [randomNumber, setRandomNumber] = useState(
    Math.floor(Math.random() * questionsAsk?.length)
  );
  const [isYes, setIsYes] = useState(false);
  const [messages, setMessages] = useState([
    { author: chatbotName, body: `Hi ${userName}, How can I help you?` },
  ]);

  useEffect(() => {
    if (AIuser?.name) {
      setUserName(AIuser?.name);
    }
  }, [AIuser]);

  const countWordsResponse = (str) => {
    return str.trim().split(/\s+/).filter(Boolean).length;
  };
  const [width, setWidth] = useState("94%");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setWidth("87%");
      } else {
        setWidth("93%");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set the initial value

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // console.log("cahtbotname =====================: ", userName);
  // console.log("cahtbotname =====================: ", loggedinUser);
  const [inputText, setInputText] = useState("");

  const [isGenerating, setIsGenerating] = useState(false);
  const [nextQues, setNextQues] = useState(location?.state?.aiType === "Consultant Ai" ? "4th" : "1st");

  const inputRef = useRef(null);
  const divRef = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [voiceCount, setVoiceCount] = useState(1);
  const [finalSubmit, setfinalSubmit] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [showAvatar, setshowAvatar] = useState(false);
  const [arrivalText, setarrivalText] = useState(false);
  const [words, setWords] = useState(0);
  const [audiocontent, setAudioContent] = useState(0);
  const [sound, setSound] = useState(null);
  const [viewMessages, setViewMessages] = useState([]);
  const inputRef2 = useRef(null);
  const wordRef = useRef(null);

  const [transactionId, setTransactionId] = useState("");

  useEffect(() => {
    // generate a random 8 character alpha numeric string

    const randomChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567891011121314156655";
    let result = "";
    for (let i = 0; i < 8; i++) {
      result += randomChars.charAt(
        Math.floor(Math.random() * randomChars.length)
      );
    }
    setTransactionId(result);
  }, []);



  const removeMarkdownForVoice = (text) => {
    if (!text) return "";
    let clean = text;
    clean = clean.replace(/#{1,6}\s?/g, "");
    clean = clean.replace(/(\*\*|__)(.*?)\1/g, "$2");
    clean = clean.replace(/(\*|_)(.*?)\1/g, "$2");
    clean = clean.replace(/^[\s]*[-*+]\s+/gm, "");
    clean = clean.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
    return clean;
  };

  const markdownComponents = {
    h1: ({ node, ...props }) => <div style={{ fontWeight: 'bold', fontSize: '1em', marginTop: '12px', marginBottom: '4px' }} {...props} />,
    h2: ({ node, ...props }) => <div style={{ fontWeight: 'bold', fontSize: '1em', marginTop: '12px', marginBottom: '4px' }} {...props} />,
    h3: ({ node, ...props }) => <div style={{ fontWeight: 'bold', fontSize: '1em', marginTop: '12px', marginBottom: '4px' }} {...props} />,
    h4: ({ node, ...props }) => <div style={{ fontWeight: 'bold', fontSize: '1em', marginTop: '12px', marginBottom: '4px' }} {...props} />,
    h5: ({ node, ...props }) => <div style={{ fontWeight: 'bold', fontSize: '1em', marginTop: '12px', marginBottom: '4px' }} {...props} />,
    h6: ({ node, ...props }) => <div style={{ fontWeight: 'bold', fontSize: '1em', marginTop: '12px', marginBottom: '4px' }} {...props} />,
  };
  // show the user name in the first question of the chatbot
  const copyMsgs = messages;
  copyMsgs[0].body = `Hi ${userName}, How can I help you?`;

  const handleScroll = (event) => {
    if (event.deltaY > 0) {
      setIsScrolling(false);
    } else if (event.deltaY < 0) {
      setIsScrolling(true);
    }
  };

  useEffect(() => {
    // if the text is generating then run the below code
    if (isGenerating === true) {
      const handleScroll = () => {
        const scrollTop = inputRef?.current?.scrollTop;
        setIsScrollingUp(scrollTop < inputRef?.current?._prevScrollTop);
        inputRef.current._prevScrollTop = scrollTop;
      };

      inputRef.current._prevScrollTop = 0;
      inputRef.current.addEventListener("scroll", handleScroll);
      const ref = inputRef.current;

      return () => {
        if (ref) {
          ref.removeEventListener("scroll", handleScroll);
        }
      };
    }
  }, [generatingtext, isGenerating]);

  useEffect(() => {
    if (isScrolling === false && isScrollingUp === false) {
      inputRef.current.scrollTop = inputRef.current.scrollHeight;
    }
    // console.log(
    //   isGenerating,
    //   text,
    //   isScrolling,
    //   isScrollingUp,
    //   generatingtext,
    //   "all the text",
    //   text == generatingtext
    // );
  }, [text, isScrolling, isScrollingUp]);

  useEffect(() => {
    if (!generatingtext) return;

    const worker = new Worker("/worker.js");
    // setMessages([...messages, { author: chatbotName, body: text }]);
    worker.addEventListener("message", (event) => {
      const { text } = event.data;

      // setIsDoneGenerating(isDone);
      if (text !== "Processing...") {
        setText(text);
      }

      setMessages([...messages, { author: chatbotName, body: text }]);
      setInputText("");
      inputRef.current.focus();
    });

    worker.postMessage({ generatingtext, words });

    if (generatingtext) {
      // console.log('hit after get the response')
      // console.log('check==================================>>>rrrrrr', [...messages, { author: chatbotName, body: generatingtext }]);
      setMessages([...messages, { author: chatbotName, body: generatingtext }]);
    }


    return () => {
      worker.terminate();
      // setarrivalText(false)
    };
  }, [generatingtext, isGenerating]);

  const handleSubmitCredits = async (points) => {
    const deductedCredits = AIuser?.credits - points;
    // console.log("question", question, conversation);

    await axios
      .put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
        { email: AIuser?.email, credits: deductedCredits },
        {
          headers: {
            authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserRefetch(!userRefetch);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsHaveViewMessage(false);
    // setarrivalText(true)

    localStorage.setItem("inputText", inputText);

    if (true) {
      setIsGenerating(true);
      setGeneratingText(() => "");
      setText("");
      setIsScrolling(false);
      setIsScrollingUp(false);

      const updatedMessages = [...messages, { author: userName, body: inputText }];
      setMessages(updatedMessages);

      const chatHistory = [];
      if (Array.isArray(messages) && messages.length > 0) {
        messages.forEach((msg) => {
          if (msg.body) {
            const isErrorMsg = msg.author === chatbotName && (msg.body === "An error occurred while generating the response." || msg.body === "Invalid prompt!");
            if (!isErrorMsg) {
              chatHistory.push({
                role: msg.author === chatbotName ? "assistant" : "user",
                content: msg.body,
              });
            }
          }
        });
      }

      try {
        const authToken = localStorage.getItem("aiUser");
        const res = await axios.post(
          "https://backend.whalesai.com/api/v1/consultant-ai/ask",
          {
            name: AIuser?.name || userName,
            question: inputText,
            chatHistory: chatHistory,
            credit: 0,
            transactionId: transactionId
          },
          {
            headers: {
              authorization: `Bearer ${authToken}`,
            },
          }
        );

        let responseText = "";
        if (res?.data?.success) {
          if (res?.data?.data?.transactionId) {
            setTransactionId(res.data.data.transactionId);
          }
          responseText = res.data.data?.answer || res.data.data?.content || res.data.data || res.data.answer || res.data;
          if (typeof responseText === "object") {
            responseText = responseText.content || responseText.response || JSON.stringify(responseText);
          }
        } else {
          responseText = res?.data?.message || "Invalid prompt!";
        }

        if (responseText && res?.data?.success) {
          let cleanResponse = typeof responseText === "string" ? responseText : String(responseText);
          cleanResponse = cleanResponse.replace(/^Assistant:\s*/, "");
          cleanResponse = cleanResponse.replace(/【.*?】/g, "");

          const voiceText = removeMarkdownForVoice(cleanResponse);
          handleSynthesize(voiceText, voice, () => {
            setGeneratingText(cleanResponse);
            setIsGenerating(false);
          });

          const points = 0;
          // handleSubmitCredits(points);

          await axios.post(
            "https://backend.whalesai.com/api/v1/credits-transaction/create",
            {
              aiType: "Consultant Ai",
              transactionId: transactionId,
              requestQues: inputText,
              response: cleanResponse,
              credit: points,
              userId: AIuser?._id,
              userName: userName,
              companionName: chatbotName,
              companionAiVoice: voice,
              companionAiGender: gender,
            }
          );
        } else {
          setGeneratingText(responseText || "Invalid prompt!");
          setIsGenerating(false);
        }
      } catch (error) {
        console.error("Error asking consultant AI:", error);
        setGeneratingText("An error occurred while generating the response.");
        setIsGenerating(false);
      }

    } else {
      setShowAlert(true);
    }
  };

  const handleClearInput = () => {
    document.getElementById("inputText").value = "";
    setInputText("");
  };

  const handleKeyDown = (event) => {
    if (
      event.key === "Enter" &&
      inputText !== "" &&
      !event.shiftKey &&
      window.innerWidth > 1000
    ) {
      if (divRef.current) {
        divRef.current.scrollIntoView({ behavior: "smooth" });
      }
      event.preventDefault();
      event.stopPropagation();
      handleSubmit(event);
    }

    if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      setInputText(inputText + "\n");
    }

    if (window.innerWidth < 1000 && event.key === "Enter") {
      event.preventDefault();
      setInputText(inputText + "\n");
    }
  };

  const onFinish = () => {
    // if (userName && chatbotName && finalSubmit) {
    if (userName && chatbotName) {
      setnameSubmitted(true);
      setUsingChat(true);

      handleSynthesize("Hi " + userName + ", how can I help you?", voice);

      // if (divRef.current) {
      //   divRef.current.scrollIntoView({ behavior: "smooth" });
      // }
      setIsShort(false);
    }
  };

  const handlePercent = (value) => {
    if (value == "1st") {
      setPercent(35);
    } else if (value == "2nd") {
      setPercent(70);
    } else {
      setPercent(100);
      // make showAvatar true after 3seconds
      setTimeout(() => {
        // setShowAvatar(true);
      }, 3000);
    }
  };

  const onChange = (value) => {
    setGender(value);
  };

  const onChangeVoices = (value) => {
    const selectedVoices = voices?.find(
      (voice) => voice.label === value.target.value,
      setChatbotName(value.target.value)
    );
    setVoice(selectedVoices.value);
    // console.log(selectedVoices.value);

    setDefaultValue(selectedVoices);
    const latestInput = localStorage.getItem("latestInput");
    handleSynthesize(latestInput, selectedVoices.value);
    // setGender(value);
  };

  useEffect(() => {
    return () => {
      if (sound) {
        sound.stop();
      }
    };
  }, [sound]);

  const toggleMute = () => {
    setIsMuted((isMuted) => !isMuted);
    const muted = isMuted;
    if (sound) {
      sound.mute(!muted);
    }
  };

  const handleSynthesize = async (input, voiceParam, onPlayCallback) => {
    try {
      localStorage.setItem("latestInput", input);
      // console.log("voiceParam", voiceParam);
      const splittedVoice = voiceParam?.split("-");

      // setVoice(voices?.[randomIndex]?.value);

      const randomVoice = defaultValue?.value;
      const splittedRandomVoice = randomVoice?.split("-");

      const response = await fetch(
        "https://texttospeech.googleapis.com/v1beta1/text:synthesize?key=AIzaSyBnaoRoWAnWm6poRcPrETHcYF0LZryXzw8",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            input: {
              text: input,
            },

            voice: {
              languageCode: voiceParam
                ? `${splittedVoice?.[0]}-${splittedVoice?.[1]}`
                : `${splittedRandomVoice?.[0]}-${splittedRandomVoice?.[1]}`,
              name: voiceParam ? voiceParam : randomVoice,
            },

            audioConfig: {
              audioEncoding: "MP3",
              speakingRate: 1.1, // 🔹 Default is 1.0
            },
          }),
        }
      );


      // console.log('responce=====>>>>>>', response);

      const data = await response.json();
      const audioContent = data.audioContent;

      setAudioContent(audioContent);

      // create a new Howler.js sound object
      const sound = new Howl({
        src: [`data:audio/mp3;base64,${audioContent}`],
        mute: isMuted,
        onload: function () {
          const duration = sound.duration();
          setAudioDuration(duration);
        },
        onplay: function () {
          setIsPlaying(true);
          if (onPlayCallback) onPlayCallback();
        },
        onend: function () {
          setIsPlaying(false);
        },
        onloaderror: function () {
          if (onPlayCallback) onPlayCallback();
        },
        onplayerror: function () {
          if (onPlayCallback) onPlayCallback();
        }
      });

      // play the sound automatically
      sound.play();
      setSound(sound);
      setIsPlaying(true); // set playing state to true initially
    } catch (err) {
      console.log(err);
      if (onPlayCallback) onPlayCallback();
    }
  };

  const randomIndex = Math.floor(Math.random() * voices?.length);

  useEffect(() => {
    // scroll to top on initial render
    window.scrollTo(0, 0);
    setDefaultValue(voices?.[randomIndex]);
    setChatbotName(voices?.[randomIndex]?.value);
    setVoice(voices?.[randomIndex]?.value);
  }, []);

  useEffect(() => {
    let i = 0;
    let textQ;
    // console.log("is loaded===========================> ::", loaded);
    if (nextQues == "1st") {
      textQ = "What is your name?";
      handleSynthesize("What is your name?", voice);
      setIsYes(false);

    } else if (nextQues == "2nd") {
      textQ = "Which consultant would you like to chat with?";
      handleSynthesize("Which consultant would you like to chat with?", voice);
    }
    const interval = setInterval(() => {

      setQuestions(textQ?.slice(0, i));
      i++;
      if (i > textQ?.length) {
        clearInterval(interval);
        if (nextQues == '2nd') setIsYes(true);
        else setIsYes(false);
      }
    }, 80);

    return () => clearInterval(interval);
  }, [nextQues, loaded, voiceCount, voice]);

  const creditTolcalString = AIuser?.credits
    ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
    : "0";

  useEffect(() => {
    if (location?.state !== null && location?.state?.aiType === "Consultant Ai") {
      setUsingChat(true);
      setVoice(location.state.companionAiVoice);
      setGender(location.state.companionAiGender);

      if (location.state.transactionId) {
        setTransactionId(location.state.transactionId);
      }

      const selectedVoices = voices?.find(
        (voice) => voice?.value === location?.state?.companionAiVoice
      );
      setDefaultValue(selectedVoices);
      const cName = selectedVoices ? selectedVoices.value : (location.state.messages?.[0]?.companionName || chatbotName);
      setChatbotName(cName);

      const pastMessages = location.state.messages || [];
      if (pastMessages.length > 0) {
        const uName = AIuser?.name || userName;
        const formattedMessages = [{ author: cName, body: `Hi ${uName}, How can I help you?` }];
        pastMessages.forEach(msg => {
          formattedMessages.push({ author: msg.userName, body: msg.userQues });
          formattedMessages.push({ author: msg.companionName, body: msg.companionAns });
        });
        setMessages(formattedMessages);
        setnameSubmitted(true);
        setIsShort(false);
        setIsHaveViewMessage(false);
      }
    }
  }, [location.state]);

  // console.log('locationnnnnnnnnnnnnnnnnnnn : ' + location.state)

  if (location.pathname == "/consultant-ai-app") {
    // console.log("its from mobile application..........");
  } else if (location.pathname == "/social-media-consultant") {
    // console.log("its from web application...........");
  }

  // Function to scroll textarea to bottom

  useEffect(() => {
    // Scroll to the bottom of the chat container when messages change
    divRef.current.scrollTop = divRef.current.scrollHeight;
  }, [messages]);

  // console.log("Total ===> ", inputText?.length);

  const nothing = (e) => {
    e.preventDefault();
  }

  const creditToLocalString = AIuser?.credits ? parseInt(Math.floor(AIuser?.credits)).toLocaleString() : "0";

  return (
    <div className="h-100 companion-ai-container">
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
        width={800}
        className="free-use-modal"
      >
        <img src={"/free-use.png"} alt="Free Use" style={{ width: '100%', height: 'auto' }} />
      </Modal>
      {/* {location?.pathname === "/social-media-consultant" && (
        <PageHeading
          title={"SOCIAL MEDIA CONSULTANT"}
          description={
            "The Social Media Consultant helps manage and optimize your social media marketing."
          }
        />
      )} */}
      <div
        className="companion-ai-main"
        style={{
          maxWidth: "872px",
          paddingInline: "12px",
          marginInline: "auto",
        }}
      >
        {/* <div className="CreditDiv">
          <button className="credits-button">
            CREDITS : {creditTolcalString}
          </button>
          {location?.pathname === "/consultant-ai-app" ? (
            <button
              className="buy-credits-button"
              onClick={() => navigate(`/purchase-app/${tokenLocal}`)}
            >
              BUY CREDITS
            </button>
          ) : (
            <button
              className="buy-credits-button"
              onClick={() => navigate("/purchase")}
            >
              BUY CREDITS
            </button>
          )}
          {location.pathname === "/consultant-ai-app" ? (
            <button
              onClick={() => navigate("/transaction-app")}
              className="money-exchange-button"
            >
              <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
            </button>
          ) : (
            <button
              onClick={() => navigate("/usage")}
              className="money-exchange-button"
            >
              <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
            </button>
          )}
        </div> */}

        <p className="all-page-title all-page-gradient-text text-center my-4">SOCIAL MEDIA CONSULTANT</p>

        <div className="credits-actions">

          <button className="credits-button">
            CREDITS : {creditToLocalString}
          </button>

          <button
            className="buy-credits-button"
            onClick={() => navigate("/purchase")}
          >
            BUY CREDITS
          </button>

          <button
            onClick={() => navigate("/usage")}
            className="money-exchange-button"
          >
            <img src={moneyExchangeIcon} alt="usage" />
          </button>

          <button
            type="button"
            className="money-exchange-button"
            onClick={() => {
              // setShowPdfModal(true);
            }}

          >
            <img src={sampleIcon} alt="See sample video" />
          </button>

        </div>
        {/* <p style={{ fontSize: '8px' }} className="text-white mb-0 mt-2 text-center">
          1 Credit per 3000 characters  (USD 0.012 based on Credits Package 3)
        </p> */}
        <div className="selectDiv mt-4 d-flex align-items-center justify-content-between">
          <p
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/do-it-yourself")}
            className="text-warning m-0"
          >
            Click here to generate contents
          </p>
          {isMuted ? (
            <Tooltip placement="top" title={"Mute"}>
              <GoMute
                className="chatai-icon-styles text-light"
                style={{
                  marginLeft: "5px",
                  fontSize: "28px",

                  cursor: "pointer",
                }}
                onClick={toggleMute}
              />
            </Tooltip>
          ) : (
            <Tooltip placement="top" title={"Unmute"}>
              <GoUnmute
                className="chatai-icon-styles text-light"
                style={{
                  marginLeft: "5px",

                  fontSize: "28px",
                  cursor: "pointer",
                }}
                onClick={toggleMute}
              />
            </Tooltip>
          )}
        </div>

        <div
          className="first-field-container"
        >
          <div
            className="companion-res-area p-3"
            ref={divRef}
            style={{ overflowY: "auto", maxHeight: "400px" }}
          >
            <div
              className=""
              ref={inputRef}
              // onScroll={handleScroll2}
              onWheel={handleScroll}
            >
              <div class="media mb-3">
                <>
                  <div class="media-body ml-3">
                    <div
                      className="text-light rounded  text-start ask-ai-fonts copy-contents"
                      ref={wordRef}
                    >
                      {showAlert == false ? (
                        <>
                          {usingChat ? (
                            <>
                              {isHaveViewMessage ? (
                                <>
                                  {viewMessages?.map((message, i) => {
                                    return (
                                      // console.log("viewMessages", message),
                                      (
                                        <div className="mb-4" key={i}>
                                          <div
                                            style={{
                                              color: "black",
                                            }}
                                          >
                                            <span
                                              className="chat-author text-uppercase"
                                              style={{
                                                fontWeight: "bold",
                                                color: "#a500b7",
                                              }}
                                            >
                                              {message?.userName}:
                                            </span>{" "}
                                            {message.userQues}
                                          </div>
                                          <div
                                            className="mb-4"
                                            style={{
                                              color: "black",
                                              whiteSpace: "pre-line",
                                            }}
                                          >
                                            <span
                                              className="chat-author text-uppercase"
                                              style={{
                                                fontWeight: "bold",
                                                color: "#003991",
                                              }}
                                            >
                                              {message?.companionName}:
                                            </span>{" "}
                                            <div style={{ color: "black", whiteSpace: "normal" }}>
                                              <ReactMarkdown components={markdownComponents}>{message.companionAns}</ReactMarkdown>
                                            </div>
                                            {/* <p>{message.companionAns}</p> */}
                                          </div>
                                        </div>
                                      )
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  {messages?.map((message, i) => {
                                    const isHuman = message?.author == userName;
                                    // console.log(message, "text m/essage");
                                    return (
                                      <div key={i}>
                                        {isHuman ? (
                                          <div
                                            className="mb-4"
                                            style={{
                                              color: "black",
                                            }}
                                          >
                                            <span
                                              className="chat-author text-uppercase"
                                              style={{
                                                fontWeight: "bold",
                                                color: "#003991",
                                              }}
                                            >
                                              {userName}:
                                            </span>{" "}
                                            {message?.body}
                                            {isGenerating && (
                                              <span className="mb-4 d-block text-to-animate-constant">
                                                Your consultant is thinking ….
                                              </span>
                                            )}
                                          </div>
                                        ) : (
                                          <>
                                            {message?.body && (
                                              <div
                                                className="mb-4"
                                                style={{
                                                  color: "black",
                                                  whiteSpace: "pre-line",
                                                }}
                                              >
                                                <span
                                                  className="chat-author text-uppercase textContainer"
                                                  style={{
                                                    color: "#003991",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  {chatbotName}:
                                                </span>{" "}
                                                <div
                                                  style={{
                                                    color: "black",
                                                    whiteSpace: "normal",
                                                  }}
                                                >
                                                  <ReactMarkdown components={markdownComponents}>{message.body}</ReactMarkdown>
                                                </div>
                                                {/* {message.body} */}
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <p class="mb-0 text-dark">
                                {/* {questions} */}
                                {
                                  //       !loaded ? <p>{loadingMsg}</p>
                                  // :
                                  <ReactMarkdown components={{
                                    h1: ({ node, ...props }) => <strong style={{ fontSize: 'inherit' }} {...props} />,
                                    h2: ({ node, ...props }) => <strong style={{ fontSize: 'inherit' }} {...props} />,
                                    h3: ({ node, ...props }) => <strong style={{ fontSize: 'inherit' }} {...props} />,
                                    h4: ({ node, ...props }) => <strong style={{ fontSize: 'inherit' }} {...props} />,
                                    h5: ({ node, ...props }) => <strong style={{ fontSize: 'inherit' }} {...props} />,
                                    h6: ({ node, ...props }) => <strong style={{ fontSize: 'inherit' }} {...props} />,
                                  }}>{questions}</ReactMarkdown>
                                }

                                {/* What is your name?
                              <br />
                              Whom you want to chat with? */}
                              </p>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <Alert
                            message="You don't have enough credits! Please buy credits to continue."
                            type="error"
                            showIcon
                          />
                        </>
                      )}
                    </div>
                  </div>
                </>
                {/* )} */}
              </div>
            </div>
          </div>
        </div>
        {nameSubmitted ? (
          <>
            <div className="second-field-container position-relative">
              <form className="text-ai-rep-form form " >
                <textarea
                  style={{ width: width }}
                  className="second-text-area"
                  type="text"
                  lang="en"
                  placeholder=""
                  value={inputText}
                  id="inputText"
                  name="inputBox"
                  onKeyDown={handleKeyDown}
                  ref={inputRef2}
                  onChange={(e) => {
                    setInputText(e.target.value);
                    setUsingChat(true);
                    setText("");
                  }}
                ></textarea>
                <button
                  className="arrow-button send h-70"
                  onClick={inputText?.length != 0 ? handleSubmit : nothing}
                  disabled={false} // Ensure the button is always enabled
                  style={{
                    cursor: inputText?.length === 0 ? "not-allowed" : "pointer", // Cursor behavior
                  }}
                >
                  <img
                    src={arrowIcon}
                    alt="image"
                    style={{
                      filter: inputText?.length === 0
                        ? "invert(66%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(86%)" // Applying #A8A8A8 color when input is empty
                        : "none", // Normal color when input is not empty
                    }}
                  />
                </button>
              </form>
            </div>

            <div className="text-center">
              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (text == generatingtext || text == "") {
                    if (!isGenerating) {
                      setInputText(questionsAsk[randomNumber]);
                      setUsingChat(true);
                      setText("");
                      let number = Math.floor(
                        Math.random() * questionsAsk?.length
                      );
                      if (number == randomNumber) {
                        number = Math.floor(
                          Math.random() * questionsAsk?.length
                        );
                      }
                      setRandomNumber(number);
                    }
                  }
                }}
                className="text-white text-center"
              >
                <span className="text-warning ">You can ask: </span>
                {questionsAsk[randomNumber]}
              </p>

              <img
                onClick={() => {
                  let number = Math.floor(Math.random() * questionsAsk?.length);
                  if (number == randomNumber) {
                    number = Math.floor(Math.random() * questionsAsk?.length);
                  }
                  setRandomNumber(number);
                }}
                style={{ cursor: "pointer" }}
                src={reload}
                alt="reload"
                width="30"
                height="30"
                className="mb-0"
              />
            </div>
            <div
              style={{ marginBottom: "10px", marginTop: "10px" }}
              className="ai-clearbtn d-flex align-items-center justify-content-center"
            >
              {inputText.length > 0 && (
                <button
                  className="comp-clear-button "
                  onClick={handleClearInput}
                >
                  CLEAR
                </button>
              )}
            </div>
          </>
        ) : (
          <div className="d-flex w-100 first-field-container">
            <Form
              name="normal_login"
              className="login-form w-100"
              initialValues={{
                remember: true,
              }}
              layout="vertical"
            >
              {nextQues == "1st" ? (
                <>
                  <Form.Item
                    className="mb-2"
                    name="userName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your Name!",
                      },
                    ]}
                    required
                  >
                    <input
                      className="text-dark selector-second"
                      style={{ borderRadius: "4px 0 0 4px" }}
                      defaultValue={AIuser?.name}
                      placeholder={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </Form.Item>
                </>
              ) : nextQues == "2nd" ? (
                <Form.Item
                  className="mb-2"
                  name="chatbotName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your chatbot Name!",
                    },
                  ]}
                  required
                >

                  <CompanionVoiceSelect
                    onChangeVoices={onChangeVoices}
                    defaultValue={defaultValue}
                    setDefaultValue={setDefaultValue}
                    setVoice={setVoice}
                    voices={voices}
                  />
                </Form.Item>
              ) : nextQues == "3rd" ? (
                <select
                  className="selector-second mb-2 h-70"
                  style={{ borderRadius: "4px 0 0 4px" }}
                  name=""
                  id=""
                  onChange={onChange}
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              ) : null}
              {nextQues == "1st" ? (
                <div className="d-flex justify-content-between text-uppercase">
                  <Form.Item>
                  </Form.Item>

                  <Form.Item>
                  </Form.Item>
                </div>
              ) : nextQues == "2nd" ? (
                <>
                  <div className="d-flex justify-content-between text-uppercase">
                    {isYes &&
                      <Form.Item>
                        <Button
                          type="warning"
                          className="login-form-button me-2 bg-warning text-uppercase"
                          variant="contained"
                          onClick={() => {
                            setNextQues("1st");
                            setIsYes(false);
                            setVoiceCount(voiceCount + 1);
                            setPercent(0);
                          }}
                        >
                          Back
                        </Button>
                      </Form.Item>
                    }
                    <Form.Item>
                    </Form.Item>
                  </div>
                </>
              ) : nextQues == "3rd" ? (
                <>
                  <div className="d-flex justify-content-between text-uppercase">
                    <Form.Item>
                      <Button
                        type="warning"
                        className="login-form-button me-2 bg-warning text-uppercase"
                        onClick={() => {
                          setNextQues("2nd");
                          setVoiceCount(voiceCount + 1);
                          setPercent(35);
                        }}
                      >
                        Back
                      </Button>
                    </Form.Item>
                    <Form.Item>
                    </Form.Item>
                  </div>
                </>
              ) : null}
            </Form>
            {
              <button
                className="arrow-button arrow"
                onClick={() => {
                  // console.log(nextQues, userName, chatbotName);
                  if (nextQues == "1st") {
                    if (userName) {
                      handlePercent("1st");
                      setNextQues("2nd");
                      setVoiceCount(voiceCount + 1);
                    }
                  }
                  if (nextQues == "2nd") {
                    // console.log("work");
                    if (chatbotName) {
                      setNextQues("4th");
                      setVoiceCount(voiceCount + 2);
                      setfinalSubmit(true);
                      onFinish();
                    }
                  }
                  if (nextQues == "3rd") {
                    setfinalSubmit(true);
                    onFinish();
                  }
                }}
              >
                <img style={{ maxWidth: "21px" }} src={arrowIcon} alt="image" />
              </button>
            }
          </div>
        )}
      </div>
      <div class="d-flex justify-content-center mt-0 pt-0">
        <Button
          type="primary"
          htmlType={"submit"}
          className="login-form-button text-uppercase mb-2"
          onClick={() => {
            window.history.replaceState({}, "", location.pathname);
            window.location.reload();
          }}
        >
          RE-START
        </Button>
      </div>
      <div className="animate text-md-center text-lg-center  text-center d-flex justify-content-center mb-5 force-small-font">
        Please do not navigate away from the browser.
        <br /> Doing so will stop the process.
      </div>
      <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
        While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
      </div>
    </div>
  );
};

export default CompanionAi;
